"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.canRunLogHandler = void 0;
function isDebugLoggingEnabled(pinoMessage) {
  if (typeof window !== 'undefined') {
    return false;
  }
  return pinoMessage.enableDebugLogging;
}
const canRunLogHandler = ({
  loggerConfiguration,
  pinoMessage,
  transportType
}) => {
  const {
    minimalSeverityLevel,
    enabled: loggingEnabled,
    filters = []
  } = loggerConfiguration;
  if (isDebugLoggingEnabled(pinoMessage)) {
    return true;
  }

  // Entire logging disabled then just return right away
  if (!loggingEnabled) {
    return false;
  }
  let canRunHandler = false;
  let matchedAnyFilter = false;
  for (const filter of filters) {
    const {
      enabled: shouldRunForRule,
      byName,
      byAreaName,
      byNameRegExp,
      byAreaNameRegExp,
      byMinimalSeverityLevel,
      byTransportType
    } = filter;
    if (byTransportType !== undefined && byTransportType !== transportType) {
      continue;
    }
    const minimalSeverityLevelWithDefault = byMinimalSeverityLevel ?? minimalSeverityLevel;
    if (minimalSeverityLevelWithDefault > pinoMessage.level) {
      continue;
    }
    if (byName !== undefined && byName !== pinoMessage.name) {
      continue;
    }
    if (byNameRegExp !== undefined && pinoMessage.name && !byNameRegExp.test(pinoMessage.name)) {
      continue;
    }
    if (byAreaName !== undefined && pinoMessage.areaName && byAreaName !== pinoMessage.areaName) {
      continue;
    }
    if (byAreaNameRegExp !== undefined && pinoMessage.areaName && !byAreaNameRegExp.test(pinoMessage.areaName)) {
      continue;
    }

    // If some filter passes then inherit the configuration from that filter
    matchedAnyFilter = true;
    canRunHandler = shouldRunForRule;
  }
  return matchedAnyFilter ? canRunHandler : pinoMessage.level >= minimalSeverityLevel;
};
exports.canRunLogHandler = canRunLogHandler;
